"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComboboxEmptyState = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ComboboxEmptyState = require("./ComboboxEmptyState.styles");
/**
 * @extends Paragraph
 * @since 8.28.0
 */
var ComboboxEmptyState = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  return /*#__PURE__*/_react.default.createElement(_ComboboxEmptyState.StyledComboboxEmptyState, (0, _extends2.default)({
    ref: forwardedRef
  }, props));
});
exports.ComboboxEmptyState = ComboboxEmptyState;
ComboboxEmptyState.displayName = 'ComboboxEmptyState';
ComboboxEmptyState.defaultProps = {
  paddingX: 'sm',
  paddingY: 1.5,
  fontColor: 'textMedium',
  children: 'No matches found.'
};